import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { InspectionType } from "../../_objects/InspectionType";
import { HttpService } from "../http.service";
import { InspectionTypeContractService } from "../interfaces/inspection-type-contract.service";
import { ElectronService } from "../../electron.service";

@Injectable({
  providedIn: "root"
})
export class InspectionTypeOnlineService extends HttpService implements InspectionTypeContractService {
  constructor(
    private http: HttpClient,
    cookieService: CookieService,
    router: Router
  ) {
    super();
    super.setCookieService(cookieService);
    super.setHttpClient(http);
    super.setRouter(router);
  }

  getInspectionTypes(): Observable<InspectionType> {
    const endpoint = super.getEndpoint("inspectionTypes");

    return this.http.get<InspectionType>(endpoint, { withCredentials: super.getWithCredentialsOption() });
  }
}
